import { jwtDecode } from 'jwt-decode'

const ID_TOKEN_KEY = "id_token"
const ID_USERNAME = "id_username"
const ID_ENTITY = "id_entity"
const ID_TOKEN_REFRESH = "id_token_refresh"

export const TokenService = {
  token() { return localStorage.getItem(ID_TOKEN_KEY) },
  tokenSave(token) { localStorage.setItem(ID_TOKEN_KEY, token) },
  tokenDelete() { localStorage.removeItem(ID_TOKEN_KEY) },
  username() { return localStorage.getItem(ID_USERNAME) },
  usernameSave(name) { localStorage.setItem(ID_USERNAME, name) },
  usernameDelete() { localStorage.removeItem(ID_USERNAME) },
  entity() { return localStorage.getItem(ID_ENTITY) },
  entitySave(entity) { localStorage.setItem(ID_ENTITY, entity) },
  entityDelete() { localStorage.removeItem(ID_ENTITY) },
  refresh() { return localStorage.getItem(ID_TOKEN_REFRESH) },
  refreshSave(token) { localStorage.setItem(ID_TOKEN_REFRESH, token) },
  refreshDelete() { localStorage.removeItem(ID_TOKEN_REFRESH) },
  getClaims() {
    const token = this.token()
    if (!token) return null
    try { return jwtDecode(token) } catch (e) { return null }
  }
}